
export default [{
	path: '/products',
	component: () => import('@/components/products/List')
}]
